"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Browser: () => Browser
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_validate = require("./validate");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneBrowser");
  return hybrid;
}
function toAuthSessionResult(param) {
  var { type, url } = param;
  if (type === "success" && url !== void 0) return {
    type,
    url
  };
  if (type === "success") throw new Error("Browser.openAuthSession: redirect without a url");
  return {
    type
  };
}
function open(url) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  (0, import_validate.assertBrowserUrl)(url, "Browser.open");
  (0, import_validate.assertOpenOptions)(options, "Browser.open");
  return native().open(url, options).catch(import_nativeError.rethrowNativeError);
}
function dismiss() {
  return native().dismiss();
}
function openAuthSession(url, redirectUrl) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  (0, import_validate.assertBrowserUrl)(url, "Browser.openAuthSession");
  (0, import_validate.assertRedirectUrl)(redirectUrl, "Browser.openAuthSession");
  (0, import_validate.assertAuthOptions)(options, "Browser.openAuthSession");
  return native().openAuthSession(url, redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : void 0, options).then(toAuthSessionResult, import_nativeError.rethrowNativeError);
}
function dismissAuthSession() {
  native().dismissAuthSession();
}
function warmup(browserPackage) {
  return native().warmup(browserPackage).catch(import_nativeError.rethrowNativeError);
}
function mayLaunchUrl(url, browserPackage) {
  (0, import_validate.assertBrowserUrl)(url, "Browser.mayLaunchUrl");
  return native().mayLaunchUrl(url, browserPackage).catch(import_nativeError.rethrowNativeError);
}
var Browser = Object.freeze({
  open,
  dismiss,
  openAuthSession,
  dismissAuthSession,
  warmup,
  mayLaunchUrl
});
//# sourceMappingURL=index.native.js.map
